import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  MotorDataDataService,
  MsdRequestData
} from "src/app/share/data-service/motor.data.service";
import { FieldData } from "src/app/share/interface/common.interface";
import { PartnerService } from "src/app/share/service/partner.service";
import { PartnerDataService } from "src/app/share/service/partnerData.service";

@Component({
  selector: "app-success",
  templateUrl: "./success.component.html",
  styleUrls: ["./success.component.scss"]
})
export class SuccessComponent implements OnInit {
  id: string;
  partnerCode: string;

  email: string;
  fieldList: FieldData[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private partnerService: PartnerService,
    private partnerDataService: PartnerDataService,
    private motorDataDataService: MotorDataDataService
  ) {
    this.id = this.activatedRoute.snapshot.params.id;
  }

  async ngOnInit(): Promise<void> {
    await this.initPartnerDetail();

    this.getDetailById();
    this.onPreventBack();
  }

  async initPartnerDetail(): Promise<void> {
    this.partnerCode = await this.partnerService.getPartnerCode();
    this.partnerDataService.getPartnerDetail(this.partnerCode);
  }

  private getDetailById(): void {
    this.motorDataDataService.getMsdRequestDetailByPolicyId(this.id).subscribe({
      next: (value: MsdRequestData) => {
        this.email = value.email;

        this.fieldList = [
          { codeDesc: "common.name", codeValue: value.name },
          { codeDesc: "common.newIC", codeValue: value.identityNo },
          { codeDesc: "common.telNo", codeValue: value.mobileNo },
          { codeDesc: "common.plateNo", codeValue: value.vehicleNo },
          {
            codeDesc: "common.insuranceRoadtaxRenewalApplicationAmt",
            codeValue: `RM ${value.roadtaxRenewalPayment.toFixed(2)}`
          }
        ];
      },
      error: () => {
        window.location.href = "/";
      }
    });
  }

  onPreventBack(): void {
    history.pushState(null, "", window.location.href);

    window.addEventListener("popstate", () => {
      history.pushState(null, "", window.location.href);
    });
  }
}
